module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step3-3-p-75c9ec9ef7b3e65dd67d61689e2a1494.gif";